import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { toast } from 'react-toastify'

import { getDiagnosisById } from '@/services/get-diagnosis-by-id'
import { Culture } from '@/types/culture'
import { Treatment } from '@/types/treatment'

export const GET_DIAGNOSIS_BY_ID = 'GET_DIAGNOSIS_BY_ID'

export function useGetDiagnosisById(
  treatment: Treatment,
  culture: Culture,
  diagnosisId?: string,
) {
  const queryKey = useMemo(
    () => [GET_DIAGNOSIS_BY_ID, { treatment, culture, diagnosisId }],
    [culture, diagnosisId],
  )

  const query = useQuery({
    queryKey,
    queryFn: async ({ signal }) => {
      const diagnosis = await getDiagnosisById(
        treatment,
        culture,
        diagnosisId!,
        {
          signal,
        },
      )

      const flightDateLabel = new Date(
        `${diagnosis.mosaic.date}T00:00`,
      ).toLocaleDateString('pt-BR')
      const registrationDateLabel = new Date(
        diagnosis.registration_date,
      ).toLocaleDateString('pt-BR')
      const concludedAtLabel = new Date(
        diagnosis.concluded_at,
      ).toLocaleDateString('pt-BR')

      return {
        id: diagnosis.id,
        imageName: diagnosis.mosaic.filename,
        demandName: diagnosis.demand_name,
        culture: diagnosis.culture,
        treatment: diagnosis.treatment,
        idUser: diagnosis.user.id,
        username: diagnosis.user.name,
        flightDate: diagnosis.mosaic.date,
        flightDateLabel,
        registrationDate: diagnosis.registration_date,
        registrationDateLabel,
        concludedAt: diagnosis.concluded_at,
        concludedAtLabel,
        status: diagnosis.status,
        project: diagnosis.project,
        gsd: diagnosis.mosaic.gsd,
        datum: diagnosis.mosaic.datum,
        perimeter: diagnosis.perimeter,
        imageType: diagnosis.mosaic.image_type,
        imageCount: diagnosis.mosaic.image_count,
        files: diagnosis.files,
      }
    },
    enabled: !!diagnosisId,
    onError(e: any) {
      toast.error(
        'Ocorreu um erro ao buscar o resumo de infestação: ' + e.message,
      )
    },
  })

  return { ...query }
}
